import { get, isEmpty } from 'lodash'

const transformToUpdateDietImageDetailsArgs = data => ({
  image: isEmpty(data.image)
    ? null
    : get(data, 'image[0].originFileObj', undefined),
  onboardingImage: isEmpty(data.onboardingImage)
    ? null
    : get(data, 'onboardingImage[0].originFileObj', undefined),
})

export default transformToUpdateDietImageDetailsArgs
